import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Styled Components"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "styled-components"
    }}>{`Styled Components`}</h1>
    <p>{`If you're already using the `}<inlineCode parentName="p">{`styled`}</inlineCode>{` API from the `}<a parentName="p" {...{
        "href": "https://emotion.sh/docs/styled"
      }}>{`@emotion/styled`}</a>{` package, those components should have access to the same theming context that Theme UI uses.
Instead of using the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component from `}<inlineCode parentName="p">{`emotion-theming`}</inlineCode>{`, you can import and use the Theme UI provider.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx, ThemeProvider } from 'theme-ui'
import theme from './theme'
import SomeComponent from './SomeComponent'

export default props => (
  <ThemeProvider theme={theme}>
    <SomeComponent />
  </ThemeProvider>
)
`}</code></pre>
    <p>{`If you're using the `}<a parentName="p" {...{
        "href": "https://styled-components.com"
      }}>{`Styled Components`}</a>{` library, we're looking into integrations for existing components, but these can usually be converted to use Emotion with a single line change to the `}<inlineCode parentName="p">{`import`}</inlineCode>{` statement.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// before
import styled from 'styled-components'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// after
import styled from '@emotion/styled'
`}</code></pre>
    <h2 {...{
      "id": "using-the-sx-prop"
    }}>{`Using the `}<inlineCode parentName="h2">{`sx`}</inlineCode>{` prop`}</h2>
    <p>{`To avoid the need for an additional dependency,
you can use the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop to create custom styled components.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx } from 'theme-ui'

export default ({ width, color, bg, ...props }) => (
  <div
    {...props}
    sx={{
      width,
      color,
      bg,
      // additional styles...
    }}
  />
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      